import { APIresponse } from "../../../model/client/response";

export const Role = (Role: APIresponse.Role) => {
  return <>{Role.name}</>;
};

